import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { RootState } from "./store/store"
import OnboardingStep, {
    onboardingStepIsOneOf
} from "../onboarding/OnboardingStep"
import {
    nextOnboardingStepExists,
    previousOnboardingStepExists
} from "../onboarding/OnboardingController"
import { ValueType } from "pokal_api"

interface OnboardingState {
    onboardingRunning: boolean
    onboardingStep: OnboardingStep
    fulfilledSteps: OnboardingStep[]
}

export function blurMainView(
    onboardingRunning: boolean,
    onboardingStep: OnboardingStep
): boolean {
    return (
        onboardingRunning &&
        onboardingStepIsOneOf(onboardingStep, [
            OnboardingStep.POST_SIGN_UP,
            OnboardingStep.SHOW_NAV,
            OnboardingStep.SHOW_NAV_LOGOUT
        ])
    )
}

export function blurTopMenu(
    onboardingRunning: boolean,
    onboardingStep: OnboardingStep
): boolean {
    return (
        onboardingRunning &&
        onboardingStepIsOneOf(onboardingStep, [OnboardingStep.POST_SIGN_UP])
    )
}

export function hidePatientSelectionViewPatientList(
    onboardingRunning: boolean,
    onboardingStep: OnboardingStep
): boolean {
    return (
        onboardingRunning &&
        onboardingStepIsOneOf(onboardingStep, [
            OnboardingStep.SHOW_PATIENT_SELECTION_VIEW,
            OnboardingStep.SHOW_PATIENT_SELECTION_VIEW_OTP,
            OnboardingStep.SHOW_PATIENT_SELECTION_VIEW_REQUESTS
        ])
    )
}

export function hidePatientSelectionViewOTP(
    onboardingRunning: boolean,
    onboardingStep: OnboardingStep
): boolean {
    return (
        onboardingRunning &&
        onboardingStepIsOneOf(onboardingStep, [
            OnboardingStep.SHOW_PATIENT_SELECTION_VIEW
        ])
    )
}

export function mockSeveritiesUsed(
    onboardingRunning: boolean,
    onboardingStep: OnboardingStep
): boolean {
    return (
        onboardingRunning &&
        onboardingStepIsOneOf(onboardingStep, [
            OnboardingStep.SHOW_PATIENT_OVERVIEW,
            OnboardingStep.SHOW_PATIENT_OVERVIEW_REPORT,
            OnboardingStep.SHOW_PATIENT_OVERVIEW_NOTES,
            OnboardingStep.SHOW_PATIENT_OVERVIEW_PHQ,
            OnboardingStep.SHOW_PATIENT_OVERVIEW_SFQ,
            OnboardingStep.SHOW_PATIENT_OVERVIEW_MOOD,
            OnboardingStep.SHOW_PATIENT_OVERVIEW_SLEEP,
            OnboardingStep.SHOW_PATIENT_OVERVIEW_CARDIAC,
            OnboardingStep.SHOW_PATIENT_OVERVIEW_STEPS,
            OnboardingStep.SHOW_PATIENT_OVERVIEW_MEDICATION,
            OnboardingStep.SHOW_PATIENT_DETAIL_VIEW_PHQ,
            OnboardingStep.SHOW_PATIENT_DETAIL_VIEW_PHQ_TREND,
            OnboardingStep.SHOW_PATIENT_DETAIL_VIEW_PHQ_LATEST,
            //OnboardingStep.SHOW_PATIENT_DETAIL_VIEW_PHQ_SETTINGS,
            OnboardingStep.SHOW_PATIENT_DETAIL_VIEW_PHQ_CURRENT,
            OnboardingStep.SHOW_PATIENT_DETAIL_VIEW_PHQ_BASELINE
        ])
    )
}

export function mockPatientUsed(
    onboardingRunning: boolean,
    _onboardingStep: OnboardingStep
): boolean {
    return onboardingRunning
}

export function mockPhqValueTypeUsed(
    onboardingRunning: boolean,
    onboardingStep: OnboardingStep
) {
    return (
        onboardingRunning &&
        onboardingStepIsOneOf(onboardingStep, [
            OnboardingStep.SHOW_PATIENT_DETAIL_VIEW_PHQ,
            OnboardingStep.SHOW_PATIENT_DETAIL_VIEW_PHQ_TREND,
            OnboardingStep.SHOW_PATIENT_DETAIL_VIEW_PHQ_LATEST,
            //OnboardingStep.SHOW_PATIENT_DETAIL_VIEW_PHQ_SETTINGS,
            OnboardingStep.SHOW_PATIENT_DETAIL_VIEW_PHQ_CURRENT,
            OnboardingStep.SHOW_PATIENT_DETAIL_VIEW_PHQ_BASELINE
        ])
    )
}

export function mockSleepValueTypeUsed(
    onboardingRunning: boolean,
    onboardingStep: OnboardingStep
) {
    return onboardingRunning && false
}

export function hidePatientSelectionViewRequests(
    onboardingRunning: boolean,
    onboardingStep: OnboardingStep
): boolean {
    return (
        onboardingRunning &&
        onboardingStepIsOneOf(onboardingStep, [
            OnboardingStep.SHOW_PATIENT_SELECTION_VIEW,
            OnboardingStep.SHOW_PATIENT_SELECTION_VIEW_OTP
        ])
    )
}

export function hidePatientOverviewReport(
    onboardingRunning: boolean,
    onboardingStep: OnboardingStep
) {
    return (
        onboardingRunning &&
        onboardingStepIsOneOf(onboardingStep, [
            OnboardingStep.SHOW_PATIENT_OVERVIEW
        ])
    )
}
export function hidePatientOverviewNotes(
    onboardingRunning: boolean,
    onboardingStep: OnboardingStep
) {
    return (
        onboardingRunning &&
        onboardingStepIsOneOf(onboardingStep, [
            OnboardingStep.SHOW_PATIENT_OVERVIEW,
            OnboardingStep.SHOW_PATIENT_OVERVIEW_REPORT
        ])
    )
}
export function hidePatientOverviewPHQ(
    onboardingRunning: boolean,
    onboardingStep: OnboardingStep
) {
    return (
        onboardingRunning &&
        onboardingStepIsOneOf(onboardingStep, [
            OnboardingStep.SHOW_PATIENT_OVERVIEW,
            OnboardingStep.SHOW_PATIENT_OVERVIEW_REPORT,
            OnboardingStep.SHOW_PATIENT_OVERVIEW_NOTES
        ])
    )
}
export function hidePatientOverviewSFQ(
    onboardingRunning: boolean,
    onboardingStep: OnboardingStep
) {
    return (
        onboardingRunning &&
        onboardingStepIsOneOf(onboardingStep, [
            OnboardingStep.SHOW_PATIENT_OVERVIEW,
            OnboardingStep.SHOW_PATIENT_OVERVIEW_REPORT,
            OnboardingStep.SHOW_PATIENT_OVERVIEW_NOTES,
            OnboardingStep.SHOW_PATIENT_OVERVIEW_PHQ
        ])
    )
}
export function hidePatientOverviewMood(
    onboardingRunning: boolean,
    onboardingStep: OnboardingStep
) {
    return (
        onboardingRunning &&
        onboardingStepIsOneOf(onboardingStep, [
            OnboardingStep.SHOW_PATIENT_OVERVIEW,
            OnboardingStep.SHOW_PATIENT_OVERVIEW_REPORT,
            OnboardingStep.SHOW_PATIENT_OVERVIEW_NOTES,
            OnboardingStep.SHOW_PATIENT_OVERVIEW_PHQ,
            OnboardingStep.SHOW_PATIENT_OVERVIEW_SFQ
        ])
    )
}
export function hidePatientOverviewSleepDuration(
    onboardingRunning: boolean,
    onboardingStep: OnboardingStep
) {
    return (
        onboardingRunning &&
        onboardingStepIsOneOf(onboardingStep, [
            OnboardingStep.SHOW_PATIENT_OVERVIEW,
            OnboardingStep.SHOW_PATIENT_OVERVIEW_REPORT,
            OnboardingStep.SHOW_PATIENT_OVERVIEW_NOTES,
            OnboardingStep.SHOW_PATIENT_OVERVIEW_PHQ,
            OnboardingStep.SHOW_PATIENT_OVERVIEW_SFQ,
            OnboardingStep.SHOW_PATIENT_OVERVIEW_MOOD
        ])
    )
}
export function hidePatientOverviewSleepLatency(
    onboardingRunning: boolean,
    onboardingStep: OnboardingStep
) {
    return (
        onboardingRunning &&
        onboardingStepIsOneOf(onboardingStep, [
            OnboardingStep.SHOW_PATIENT_OVERVIEW,
            OnboardingStep.SHOW_PATIENT_OVERVIEW_REPORT,
            OnboardingStep.SHOW_PATIENT_OVERVIEW_NOTES,
            OnboardingStep.SHOW_PATIENT_OVERVIEW_PHQ,
            OnboardingStep.SHOW_PATIENT_OVERVIEW_SFQ,
            OnboardingStep.SHOW_PATIENT_OVERVIEW_MOOD
        ])
    )
}
export function hidePatientOverviewSleepHeartRate(
    onboardingRunning: boolean,
    onboardingStep: OnboardingStep
) {
    return (
        onboardingRunning &&
        onboardingStepIsOneOf(onboardingStep, [
            OnboardingStep.SHOW_PATIENT_OVERVIEW,
            OnboardingStep.SHOW_PATIENT_OVERVIEW_REPORT,
            OnboardingStep.SHOW_PATIENT_OVERVIEW_NOTES,
            OnboardingStep.SHOW_PATIENT_OVERVIEW_PHQ,
            OnboardingStep.SHOW_PATIENT_OVERVIEW_SFQ,
            OnboardingStep.SHOW_PATIENT_OVERVIEW_MOOD,
            OnboardingStep.SHOW_PATIENT_OVERVIEW_SLEEP
        ])
    )
}
export function hidePatientOverviewSleepHeartRateVariability(
    onboardingRunning: boolean,
    onboardingStep: OnboardingStep
) {
    return (
        onboardingRunning &&
        onboardingStepIsOneOf(onboardingStep, [
            OnboardingStep.SHOW_PATIENT_OVERVIEW,
            OnboardingStep.SHOW_PATIENT_OVERVIEW_REPORT,
            OnboardingStep.SHOW_PATIENT_OVERVIEW_NOTES,
            OnboardingStep.SHOW_PATIENT_OVERVIEW_PHQ,
            OnboardingStep.SHOW_PATIENT_OVERVIEW_SFQ,
            OnboardingStep.SHOW_PATIENT_OVERVIEW_MOOD,
            OnboardingStep.SHOW_PATIENT_OVERVIEW_SLEEP
        ])
    )
}
export function hidePatientOverviewSteps(
    onboardingRunning: boolean,
    onboardingStep: OnboardingStep
) {
    return (
        onboardingRunning &&
        onboardingStepIsOneOf(onboardingStep, [
            OnboardingStep.SHOW_PATIENT_OVERVIEW,
            OnboardingStep.SHOW_PATIENT_OVERVIEW_REPORT,
            OnboardingStep.SHOW_PATIENT_OVERVIEW_NOTES,
            OnboardingStep.SHOW_PATIENT_OVERVIEW_PHQ,
            OnboardingStep.SHOW_PATIENT_OVERVIEW_SFQ,
            OnboardingStep.SHOW_PATIENT_OVERVIEW_MOOD,
            OnboardingStep.SHOW_PATIENT_OVERVIEW_SLEEP,
            OnboardingStep.SHOW_PATIENT_OVERVIEW_CARDIAC
        ])
    )
}

export function hidePatientOverviewMedication(
    onboardingRunning: boolean,
    onboardingStep: OnboardingStep
) {
    return (
        onboardingRunning &&
        onboardingStepIsOneOf(onboardingStep, [
            OnboardingStep.SHOW_PATIENT_OVERVIEW,
            OnboardingStep.SHOW_PATIENT_OVERVIEW_REPORT,
            OnboardingStep.SHOW_PATIENT_OVERVIEW_NOTES,
            OnboardingStep.SHOW_PATIENT_OVERVIEW_PHQ,
            OnboardingStep.SHOW_PATIENT_OVERVIEW_SFQ,
            OnboardingStep.SHOW_PATIENT_OVERVIEW_MOOD,
            OnboardingStep.SHOW_PATIENT_OVERVIEW_SLEEP,
            OnboardingStep.SHOW_PATIENT_OVERVIEW_CARDIAC,
            OnboardingStep.SHOW_PATIENT_OVERVIEW_STEPS
        ])
    )
}

export function hidePatientOverviewValueTypeBox(
    onboardingRunning: boolean,
    onboardingStep: OnboardingStep,
    valueType: ValueType
) {
    switch (valueType) {
        case ValueType.PHQUESTIONNAIRE:
            return hidePatientOverviewPHQ(onboardingRunning, onboardingStep)
        case ValueType.SFQUESTIONNAIRE:
            return hidePatientOverviewSFQ(onboardingRunning, onboardingStep)
        case ValueType.MOOD:
            return hidePatientOverviewMood(onboardingRunning, onboardingStep)
        case ValueType.SLEEP_DURATION:
            return hidePatientOverviewSleepDuration(
                onboardingRunning,
                onboardingStep
            )
        case ValueType.SLEEP_LATENCY:
            return hidePatientOverviewSleepLatency(
                onboardingRunning,
                onboardingStep
            )
        case ValueType.SLEEP_HEART_RATE:
            return hidePatientOverviewSleepHeartRate(
                onboardingRunning,
                onboardingStep
            )
        case ValueType.SLEEP_HEART_RATE_VARIABILITY:
            return hidePatientOverviewSleepHeartRateVariability(
                onboardingRunning,
                onboardingStep
            )
        case ValueType.STEPS:
            return hidePatientOverviewSteps(onboardingRunning, onboardingStep)
    }
}

export function hidePatientDetailViewDataPreferences(
    onboardingRunning: boolean,
    onboardingStep: OnboardingStep
) {
    return (
        onboardingRunning &&
        onboardingStepIsOneOf(onboardingStep, [
            OnboardingStep.SHOW_PATIENT_DETAIL_VIEW_PHQ,
            OnboardingStep.SHOW_PATIENT_DETAIL_VIEW_PHQ_TREND,
            OnboardingStep.SHOW_PATIENT_DETAIL_VIEW_PHQ_LATEST,
            OnboardingStep.SHOW_PATIENT_DETAIL_VIEW_PHQ_CURRENT,
            OnboardingStep.SHOW_PATIENT_DETAIL_VIEW_PHQ_BASELINE
        ])
    )
}

export function hidePatientDetailViewDataBaseline(
    onboardingRunning: boolean,
    onboardingStep: OnboardingStep
) {
    return (
        onboardingRunning &&
        onboardingStepIsOneOf(onboardingStep, [
            OnboardingStep.SHOW_PATIENT_DETAIL_VIEW_PHQ,
            OnboardingStep.SHOW_PATIENT_DETAIL_VIEW_PHQ_TREND,
            OnboardingStep.SHOW_PATIENT_DETAIL_VIEW_PHQ_LATEST,
            OnboardingStep.SHOW_PATIENT_DETAIL_VIEW_PHQ_CURRENT
        ])
    )
}

export function hidePatientDetailViewDataCurrent(
    onboardingRunning: boolean,
    onboardingStep: OnboardingStep
) {
    return (
        onboardingRunning &&
        onboardingStepIsOneOf(onboardingStep, [
            OnboardingStep.SHOW_PATIENT_DETAIL_VIEW_PHQ,
            OnboardingStep.SHOW_PATIENT_DETAIL_VIEW_PHQ_TREND,
            OnboardingStep.SHOW_PATIENT_DETAIL_VIEW_PHQ_LATEST
        ])
    )
}

export function hidePatientDetailViewDataLatest(
    onboardingRunning: boolean,
    onboardingStep: OnboardingStep
) {
    return (
        onboardingRunning &&
        onboardingStepIsOneOf(onboardingStep, [
            OnboardingStep.SHOW_PATIENT_DETAIL_VIEW_PHQ,
            OnboardingStep.SHOW_PATIENT_DETAIL_VIEW_PHQ_TREND
        ])
    )
}

export function hidePatientDetailViewDataTrend(
    onboardingRunning: boolean,
    onboardingStep: OnboardingStep
) {
    return (
        onboardingRunning &&
        onboardingStepIsOneOf(onboardingStep, [
            OnboardingStep.SHOW_PATIENT_DETAIL_VIEW_PHQ
        ])
    )
}

export function medicationOnboardingIsRunning(
    onboardingRunning: boolean,
    onboardingStep: OnboardingStep
) {
    return onboardingRunning && onboardingStepIsOneOf(onboardingStep, [
        OnboardingStep.SHOW_PATIENT_MEDICATION
    ])
}

const name = "onboardingSlice"
const initialState: OnboardingState = {
    onboardingRunning: false,
    onboardingStep: OnboardingStep.POST_SIGN_UP,
    fulfilledSteps: []
}
const onboardingSlice = createSlice({
    name,
    initialState,
    reducers: {
        toggleOnBoardingState: (state) => {
            if (!state.onboardingRunning) {
                state.onboardingRunning = !state.onboardingRunning
                state.onboardingStep = OnboardingStep.POST_SIGN_UP
            } else {
                state.onboardingRunning = false
                state.fulfilledSteps = []
            }
        },
        increaseOnboardingStep: (state) => {
            if (!state.fulfilledSteps.includes(state.onboardingStep))
                state.fulfilledSteps = [
                    ...state.fulfilledSteps,
                    state.onboardingStep
                ]
            if (nextOnboardingStepExists(state.onboardingStep))
                state.onboardingStep = state.onboardingStep + 1
            else {
                state.onboardingStep = OnboardingStep.POST_SIGN_UP
                state.onboardingRunning = false
            }
        },
        decreaseOnboardingStep: (state) => {
            if (previousOnboardingStepExists(state.onboardingStep))
                state.onboardingStep = state.onboardingStep - 1
        },
        setOnboardingStep: (state, action: PayloadAction<number>) => {
            state.onboardingStep = action.payload
        }
    }
})

export const {
    toggleOnBoardingState,
    increaseOnboardingStep,
    decreaseOnboardingStep,
    setOnboardingStep
} = onboardingSlice.actions

export const selectOnboardingIsRunningState = (state: RootState) =>
    state.onboarding.onboardingRunning

export const selectOnboardingStep = (state: RootState) =>
    state.onboarding.onboardingStep

export const selectFulfilledOnboardingSteps = (state: RootState) =>
    state.onboarding.fulfilledSteps

export default onboardingSlice.reducer
